module.exports = __webpack_public_path__ + "img/vlimsoft.ad017d48.jpg";